import {IService, SystemComponentType} from '@gongxigames/framework/core/types';
import {CommandLineInterface} from '@gongxigames/framework/core/fragments/cli/CommandLineInterface';
import {injectable} from '@gongxigames/framework/core/installer';
import {BrowserConsoleInterface} from '@gongxigames/framework/core/fragments/cli/BrowserConsoleInterface';
import {CoreDI} from '@gongxigames/framework/core/configs/CoreDI';

@injectable()
export class CommandLineInterfaceService extends CommandLineInterface implements IService {
    public static NAME: symbol = CoreDI.CLI;
    constructor() {
        super();

        this.addInterface(new BrowserConsoleInterface());
    }
    public destroy(): void {
        this.clear();
    }

    public type: SystemComponentType = 'service';
}
